module.exports = __webpack_public_path__ + "static/media/ch.82594881.webp";